module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "dark": _vm.dark,
      "flat": "",
      "height": "100%"
    }
  }, [_c('v-img', {
    class: {
      "white--text": !_vm.dark
    },
    attrs: {
      "src": _vm.backgroundImg,
      "height": "180px",
      "gradient": "to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
    }
  }, [_c('v-layout', [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mt-4",
          attrs: {
            "slot": "activator",
            "fab": "",
            "small": "",
            "absolute": "",
            "top": "",
            "right": "",
            "dark": ""
          },
          slot: "activator"
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), (_vm.appointment) ? _c('action-list', {
    attrs: {
      "appointment": _vm.appointment
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.sharelink && _vm.sharelink.url) ? _c('v-btn', {
    staticClass: "mb-5",
    attrs: {
      "fab": "",
      "small": "",
      "absolute": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    on: {
      "click": _vm.share
    }
  }, [_c('v-icon', [_vm._v("share")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('h3', {
    staticClass: "title font-weight-light mt-3 ml-3 grow"
  }, [_vm._v("\n            " + _vm._s(_vm.appointment.title) + "\n            "), _c('small', [_vm._v("with " + _vm._s(_vm.appointment.practitioner_name))])]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.appointment.product_name) + " @ " + _vm._s(_vm.appointment.space_name))])]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('strong', {
    staticClass: "display-4 font-weight-regular mr-4 ml-3"
  }, [_vm._v("\n          " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'D')) + "\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "headline font-weight-light"
  }, [_vm._v("\n            " + _vm._s(_vm.dateformat(_vm.appointment.start_time, 'ddd')) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase font-weight-light"
  }, [_vm._v(_vm._s(_vm.dateformat(_vm.appointment.start_time, 'MMMM YYYY')))]), _vm._v(" "), _c('div', [_vm._v(" ")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "dark": ""
    }
  }, [(_vm.relationship && _vm.relationship.id) ? _c('client-list-item', {
    attrs: {
      "with-details": "",
      "relationship-id": _vm.relationship.id,
      "client": _vm.relationship.client
    },
    on: {
      "listitem:clicked": function($event) {
        return _vm.gotoClient(_vm.relationship)
      }
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "slot": "avatar"
    },
    slot: "avatar"
  }, [_c('v-icon', [_vm._v("person")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return _c('v-list-tile', {
          attrs: {
            "avatar": ""
          }
        }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Date and time")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n          ")]), _vm._v(" "), (_vm.appointment.client_timezone && _vm.appointment.client_timezone !== _vm.$store.getters.settings.timezone) ? _c('v-list-tile-sub-title', [_vm._v("\n            Client's timezone: " + _vm._s(_vm.appointment.client_timezone) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.openGlobalDialog(true, 'Reschedule', {
                appointment: _vm.appointment
              })
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1)], 1)], 1)
      }
    }])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.location && (_vm.appointment.location.address || _vm.appointment.location.name)) ? [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Flexible location")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.formatted_address || _vm.appointment.location.address)
    }
  })], 1), _vm._v(" "), (_vm.appointment.location.url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointment.location.url,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e()], 1)] : (_vm.appointment.zoom_join_url) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Online")]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
    attrs: {
      "href": _vm.appointment.zoom_join_url,
      "title": "Join URL",
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.appointment.zoom_join_url))])]), _vm._v(" "), (_vm.appointment.zoom_meeting_password) ? _c('v-list-tile-sub-title', [_vm._v("\n          Password: " + _vm._s(_vm.appointment.zoom_meeting_password) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.appointment.zoom_start_url) ? _c('v-list-tile-action', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "href": _vm.appointment.zoom_start_url,
            "target": "_blank",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
      }
    }], null, false, 3002636037)
  }, [_vm._v(" "), _c('span', [_vm._v("Meeting start URL")])])], 1) : _vm._e()], 1) : (_vm.appointment.address_data) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Location")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.appointment.address_data.name) + ". " + _vm._s(_vm.appointment.address_data.address) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.product && _vm.product.id) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Appointment Type")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.product.title) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment.codes) ? [_c('appointment-codes', {
    attrs: {
      "dense": "",
      "with-title": "",
      "with-total": "",
      "appointment-id": _vm.appointment.id,
      "value": _vm.appointment,
      "with-done": false,
      "title": "Codes"
    }
  })] : _vm._e(), _vm._v(" "), _vm._t("card-actions", function() {
    return [_c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', [_vm._v("Open")])], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a221d1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/SmallAppointmentCard.vue
// module id = 1456
// module chunks = 9